import React from 'react';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

import LaoThan from './image/booking/laothan.png';
// Dữ liệu lịch trình chuyến đi Tà Chì Nhù
const Schedule = [
  {
    day: "Chiều Thứ 6",
    activities: [
      { time: "06:30 PM", description: "Khởi hành từ Hà Nội, bắt đầu hành trình tìm về vùng viễn biên Y Tý" },
      { time: "11:30 PM", description: "Có mặt và nhận phòng tại homestay tại Y Tý - Lào Cai" },
      { 
        description: "Giữa cái se lạnh của vùng cao ở độ cao 2.000m, hãy tự thưởng cho mình một giấc ngủ thật sâu. Một cơ thể được nghỉ ngơi trọn vẹn sẽ giúp bạn có một diện mạo rạng rỡ nhất để đón chờ biển mây vào ngày mai." 
      }
    ],
  },
  {
    day: "Thứ 7 - Săn Hoàng Hôn Trên Đỉnh Nhọn",
    activities: [
      { time: "06:30 AM", description: "Ăn sáng đặc sản địa phương và ngắm nhìn bản làng chìm trong sương" },
      { 
        description: "Bữa sáng đầy đủ dinh dưỡng là sự chuẩn bị tinh tế để đôi chân luôn bền bỉ. Tại đây, bạn có thể gửi lại những hành lý không cần thiết, chỉ mang theo những gì nhẹ nhàng nhất để tự do phiêu lưu cùng mây trời." 
      },
      { time: "07:30 AM", description: "Di chuyển bằng xe máy xuyên qua những cung đường núi đầy phấn khích" },
      { 
        description: "Ngồi sau tay lái của những người dân bản địa, băng qua những thung lũng mây và những cánh rừng già. Mỗi khúc cua là một món quà của thiên nhiên dành tặng cho những tâm hồn yêu tự do như bạn." 
      },
      { time: "08:30 AM", description: "Bắt đầu hành trình trekking chinh phục Nóc nhà Y Tý" },
      { 
        description: "Chúng ta sẽ đi dưới những tán cây rừng thưa và những đồng cỏ bao la. Đừng lo lắng, các Porter nhiệt tình đã chuẩn bị sẵn nước uống và những vật dụng cần thiết để bạn chỉ việc tận hưởng hành trình này." 
      },
      { time: "12:00 PM", description: "Nghỉ chân và dùng bữa trưa picnic giữa không gian xanh mướt" },
      { 
        description: "Giấc ngủ trưa 15 phút giữa tiếng gió xào xạc của đại ngàn sẽ giúp bạn phục hồi năng lượng một cách diệu kỳ. Hãy để đôi tai được lắng nghe nhịp đập của núi rừng Y Tý." 
      },
      { time: "04:30 PM", description: "Chạm đỉnh Lảo Thẩn (2.860m) - Ngắm hoàng hôn rực rỡ" },
      { 
        description: "Chúc mừng bạn đã chinh phục đỉnh cao! Khi ánh mặt trời dần buông, cả biển mây sẽ nhuộm màu vàng cam rực rỡ. Hãy lưu giữ những bức ảnh đẹp nhất của thanh xuân giữa khoảnh khắc huyền ảo này nhé." 
      },
      { time: "06:30 PM", description: "Thưởng thức bữa tối đặc sản Tây Bắc tại lán nghỉ" },
      { 
        description: "Một đêm 'Detox kỹ thuật số' hoàn hảo. Trong không gian không sóng điện thoại, bên bếp lửa hồng và mâm cơm ấm cúng với gà đen, lợn bản, chúng ta sẽ xích lại gần nhau hơn trong hơi ấm của tình đồng hành." 
      },
    ],
  },
  {
    day: "Chủ Nhật - Bình Minh Vàng & Sự Phục Hồi",
    activities: [
      { time: "04:30 AM", description: "Thức dậy đón những cột nắng đầu tiên trên đỉnh núi" },
      { 
        description: "Chuẩn bị hành trang nhẹ nhàng để quay lại đỉnh hoặc các mỏm đá gần lán ngắm bình minh. Hãy giữ ấm cơ thể bằng một chiếc khăn quàng nhẹ, bạn sẽ thấy mình như đang đứng giữa thiên đường." 
      },
      { time: "05:30 AM", description: "Đón bình minh rực rỡ trên biển mây Lảo Thẩn" },
      { 
        description: "Đây là khoảnh khắc vàng để bạn đứng giữa những cột nắng sớm. Đừng quên lưu giữ khoảnh khắc để đời tại 'Cây sống ảo' hay 'Mỏm đá câu cá' nổi tiếng trước khi nói lời tạm biệt với sân thượng săn mây này." 
      },
      { time: "07:30 AM", description: "Bữa sáng trên mây và thu dọn hành trang xuống núi" },
      { 
        description: "Hãy kiểm tra kỹ lưỡng dây giày và đảm bảo không bỏ sót bất kỳ vật dụng cá nhân nào. Sự an toàn và thoải mái của bạn luôn là ưu tiên hàng đầu trong mỗi bước chân xuống dốc." 
      },
      { time: "11:00 AM", description: "Về tới chân núi, xe đón đoàn trở về homestay" },
      { time: "12:00 PM", description: "Tắm nước nóng lá thuốc và dùng bữa trưa chia tay" },
      { 
        description: "Dòng nước nóng thơm mùi thảo mộc sẽ giúp bạn trút bỏ mọi mệt mỏi, làm mới lại làn da và tinh thần sau một hành trình đầy cảm hứng." 
      },
      { time: "01:30 PM", description: "Lên xe khởi hành trở về Hà Nội" },
      { time: "08:30 PM", description: "Về tới Hà Nội - Kết thúc hành trình thành công và đầy ắp kỷ niệm" },
      { 
        description: "Tạm biệt Y Tý, chúng ta mang về không chỉ là những bức ảnh đẹp, mà là sự tự tin và nguồn năng lượng mới cho tuần làm việc sắp tới. Hẹn gặp lại bạn ở những đỉnh cao tiếp theo!" 
      }
    ],
  },
];

const LaoThanSchedule = () => {
  const exportPDF = () => {
    const input = document.getElementById("schedule");
    html2canvas(input, { scale: 1.5 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/jpeg", 0.7); // 0.7 = chất lượng nén
      const imgWidth = 210;
      const pageHeight = (canvas.height * imgWidth) / canvas.width;

      const pdf = new jsPDF("p", "mm", [imgWidth, pageHeight]);
      pdf.addImage(imgData, "JPEG", 0, 0, imgWidth, pageHeight, null, "FAST");
      pdf.save("lich-trinh-lao-than.pdf");
    });
  };


  return (
    <div>
    <div id="schedule" className="schedule-container" style={{ fontFamily: 'Arial, sans-serif', maxWidth: '800px', margin: '0 auto', padding: '1px' }}>
      <div  className="day-schedule" style={{ marginBottom: '30px', borderLeft: '3px solid #6b8e23', paddingLeft: '1px' }}>
        <p className='block text-5xl font-sans font-bold italic px-1 py-2'>
          ☁️ Lảo Thẩn – Sân Thượng Săn Mây Tuyệt Đỉnh của Y Tý
        </p>
        <p className='block text-lg font-sans italic px-3 py-2'>
          Lảo Thẩn – ngọn núi cao 2.860 mét, được mệnh danh là “Nóc nhà Y Tý” và là điểm đến mơ ước của những người yêu săn mây. 
          Đây không chỉ là một cung đường trekking vừa sức, mà còn là “Sân thượng” lý tưởng nhất để bạn đón 
          chào khoảnh khắc Bình Minh Vàng rực rỡ và đắm mình trong biển mây bồng bềnh cuồn cuộn dưới chân.
        </p>
        <p  className='block text-lg font-italic font-sans italic px-5 py-2'>
          Ảnh: Bình minh trên núi Lảo Thẩn
        </p>
        <img src={LaoThan} alt="" className="w-96 bg-white shadow-md border-4 border-white p-5 rounded-lg w-11/12" />
      </div>
        <h2 className ='text-5xl' style={{ color: '#387338', borderBottom: '2px solid #a8c6a8', paddingBottom: '10px' }}>
          Chi tiết
        </h2>
      {Schedule.map((dayData, index) => (
        <div key={index} className="day-schedule" style={{ marginBottom: '30px', borderLeft: '3px solid #6b8e23', paddingLeft: '15px' }}>
          <h3 style={{ color: '#6b8e23', backgroundColor: '#f0fff0', padding: '5px 10px', borderRadius: '4px' }}>
            {dayData.day}
          </h3>
          <ul style={{ listStyle: 'none', paddingLeft: '0' }}>
            {dayData.activities.map((activity, idx) => (
              <li key={idx} className="activity-item text-lg font-sans " style={{ marginBottom: '15px', display: 'flex' }}>
                <strong style={{ minWidth: '85px', color: '#333' }}>
                  {activity.time}
                </strong>
                <span style={{ flexGrow: 1, paddingLeft: '10px' }}>
                  {activity.description}
                </span>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
    <button 
        onClick={exportPDF}
        className=" m-5 px-5 py-2 bg-green-600 text-white px-4 py-2 rounded-md mb-4"
      >
        Xuất PDF
    </button>
  </div>
  );
};

export default LaoThanSchedule;